export default __webpack_public_path__ + "static/media/carlLoryR2E_2.c9c2fc9f.png";